module.exports = __webpack_public_path__ + "static/media/CookielessOutlined.16a411c3.svg";